import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineHeight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="line-height, spacing, eleborate"><path d="M2.75 4.75H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 19.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 10L12 7.75L14.25 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 14.25L12 16.5L14.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconLineHeight;
